import { Paper, SimpleGrid } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import CollapsibleSection from '@v2/commons/components/ModalCollapsibleSection/ModalCollapsibleSection.component'

import {
  EscalationProgramEnum,
  MutateEscalationData,
} from '../../escalation.types'
import EscalationCaseFormHeader from '../FormCardHeader/escalationFormHeader.component'
import EscalationFormFields from '../FormFields/escalationFormFields.component'

interface Props {
  updateEscalationForm: UseFormReturnType<MutateEscalationData>
  isSubmittedForm: boolean
  program: EscalationProgramEnum
  hasEditPolicy: boolean
}
const EscalationCaseForm = ({
  updateEscalationForm,
  isSubmittedForm,
  program,
  hasEditPolicy,
}: Props) => {
  return (
    <Paper mb={32}>
      <CollapsibleSection header="Case Information" open={true}>
        <SimpleGrid spacing={20}>
          <EscalationCaseFormHeader program={program} />
          <EscalationFormFields
            updateEscalationForm={updateEscalationForm}
            readOnly={isSubmittedForm || hasEditPolicy}
          />
        </SimpleGrid>
      </CollapsibleSection>
    </Paper>
  )
}
export default EscalationCaseForm
